package org.multiplatform.kotfolio.components

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.styles.CheckIndicator
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P

@Composable
fun OurValueItem(modifier: Modifier = Modifier, title: String, description: String) {
    Row(
        modifier = Modifier
            .padding(16.px)
            .then(modifier),
    ) {
        CheckIndicator(
            modifier = Modifier
                .margin(right = 12.px)
        )
        TextValue(
            title = title, description = description
        )
    }
}

@Composable
private fun TextValue(
    modifier: Modifier = Modifier,
    title: String,
    description: String
) {
    P(
        attrs = Modifier
            .fillMaxWidth()
            .margin(topBottom = 0.px)
            .fontSize(14.px)
            .fontWeight(FontWeight.Normal)
            .lineHeight(1.6)
            .letterSpacing(1.2.px)
            .then(modifier)
            .toAttrs()
    ) {
        SpanText(
            text = "${title}: ",
            modifier = Modifier
                .fontWeight(FontWeight.Light)
                .letterSpacing(1.5.px)
                .fontSize(18.px)
        )
        SpanText(
            description, modifier = Modifier
                .fontSize(FontSize.Medium)
        )
    }
}